import { useTranslation } from 'react-i18next';
import { Typography } from 'app/components';

import './RemoveUser.scss';

export const RemoveUser = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation('document-permissions');

  return (
    <div className="remove-user">
      <button onClick={() => onClick()} className="remove-user__button">
        <i className="fa-regular fa-trash-can" />
        <Typography variant="body-7" fontWeight="light" color="rgb(30, 37, 51)">
          {t('list.menu-item.remove-user')}
        </Typography>
      </button>
    </div>
  );
};
